import axios from 'axios';
import { API_BASE_URL, API_ENDPOINTS } from '../config/api';

export interface FeatureFlags {
  useDummyDataWhenEmpty: boolean;
  cgmDashboardRefreshSeconds: number;
  showQuickActions: boolean;
}

export const configService = {
  async getFeatureFlags(): Promise<FeatureFlags> {
    try {
      const res = await axios.get<FeatureFlags>(
        `${API_BASE_URL}${API_ENDPOINTS.CONFIG.FEATURE_FLAGS}`,
        { timeout: 10000 }
      );
      const data = res.data;
      const refresh = Number(data?.cgmDashboardRefreshSeconds);
      return {
        useDummyDataWhenEmpty: Boolean(data?.useDummyDataWhenEmpty),
        cgmDashboardRefreshSeconds:
          Number.isFinite(refresh) && refresh >= 5 ? Math.floor(refresh) : 30,
        showQuickActions: Boolean(data?.showQuickActions),
      };
    } catch {
      return {
        useDummyDataWhenEmpty: false,
        cgmDashboardRefreshSeconds: 30,
        showQuickActions: false,
      };
    }
  },
};
